import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { ExposureType } from '../index';
import { encodeObject } from '../util/encode';
export var ONE_HOUR = 1000 * 60 * 60;
var ExposureEvents = /*#__PURE__*/function () {
  function ExposureEvents(analyticsWebClient) {
    _classCallCheck(this, ExposureEvents);
    _defineProperty(this, "spamBuster", {});
    _defineProperty(this, "automaticExposuresEnabled", false);
    _defineProperty(this, "automaticExposuresPredicate", function () {
      return true;
    });
    this.analyticsWebClient = analyticsWebClient;
  }
  _createClass(ExposureEvents, [{
    key: "sendExposureEvent",
    value: function sendExposureEvent(flagKey, validatedFlag, isExplicitlyRequested, exposureData) {
      var evaluationDetail = validatedFlag.evaluationDetail,
        _validatedFlag$tracki = validatedFlag.trackingInfo,
        trackingInfo = _validatedFlag$tracki === void 0 ? {
          samplingRate: 0
        } : _validatedFlag$tracki;

      // Only attach custom exposure data to opt-in exposure events.
      // This is done because the compression and storage for automatic exposure events do not currently
      // support custom attributes. By intentionally excluding them, we ensure that we are not collecting
      // data that will eventually be dropped further in the pipeline.
      // See https://hello.atlassian.net/wiki/spaces/MEASURE/pages/1316354396/RFC-002+Automatic+exposure+event+collection+in+the+Fx3+web+client for more information.
      var customAttributes = isExplicitlyRequested ? exposureData : {};
      var hasCustomAttributes = customAttributes ? Object.keys(customAttributes).length > 0 : false;
      var exposureAttributes = {
        flagKey: flagKey,
        value: validatedFlag.value,
        reason: evaluationDetail === null || evaluationDetail === void 0 ? void 0 : evaluationDetail.reason,
        ruleId: evaluationDetail === null || evaluationDetail === void 0 ? void 0 : evaluationDetail.ruleId,
        errorKind: evaluationDetail === null || evaluationDetail === void 0 ? void 0 : evaluationDetail.errorKind
      };
      var allAttributes = _objectSpread(_objectSpread({}, customAttributes), exposureAttributes);
      var shouldSendExposureEvent = this.shouldSendExposureEvent(allAttributes, trackingInfo, isExplicitlyRequested);
      if (shouldSendExposureEvent) {
        var actionSubject = 'feature';
        var action = 'exposed';
        var source = '@atlassiansox/feature-flag-web-client';
        var highPriority = isExplicitlyRequested;
        this.analyticsWebClient.sendOperationalEvent({
          actionSubject: actionSubject,
          action: action,
          attributes: exposureAttributes,
          tags: ['measurement', isExplicitlyRequested ? ExposureType.OptIn : ExposureType.Automatic],
          source: source,
          highPriority: highPriority
        });

        // Due to the way we've simplified our pipeline, custom attributes are dropped from exposure
        // events. In order not to break existing users of this feature immediately, we're sending an
        // extra event that won't be consumed by our pipeline, but will end up in the `cloud.*` tables.
        // See: https://hello.atlassian.net/wiki/spaces/MEASURE/pages/1838596497/AtlasKit+TAC
        if (hasCustomAttributes) {
          this.analyticsWebClient.sendOperationalEvent({
            actionSubject: actionSubject,
            action: action,
            attributes: allAttributes,
            tags: ['measurement', ExposureType.OptIn, ExposureType.HasCustomAttributes],
            source: source,
            highPriority: highPriority
          });
        }
        this.markExposureAsTracked(exposureAttributes);
      }
    }
  }, {
    key: "shouldSendExposureEvent",
    value: function shouldSendExposureEvent(exposureAttributes, trackingInfo, isExplicitlyRequested) {
      if (this.hasAlreadyTrackedExposure(exposureAttributes)) {
        return false;
      }
      if (isExplicitlyRequested) {
        return true;
      }
      var samplingRate = trackingInfo.samplingRate;
      var shouldSendAutomaticEvent = this.automaticExposuresEnabled && samplingRate === 1 && this.automaticExposuresPredicate(exposureAttributes);
      return shouldSendAutomaticEvent;
    }
  }, {
    key: "hasAlreadyTrackedExposure",
    value: function hasAlreadyTrackedExposure(attributes) {
      var encode = encodeObject(attributes);
      if (this.spamBuster[encode] === undefined || this.spamBuster[encode] + ONE_HOUR < Date.now()) {
        return false;
      }
      return true;
    }
  }, {
    key: "markExposureAsTracked",
    value: function markExposureAsTracked(attributes) {
      var encode = encodeObject(attributes);
      this.spamBuster[encode] = Date.now();
    }
  }, {
    key: "setAutomaticExposuresEnabled",
    value: function setAutomaticExposuresEnabled(enabled) {
      var predicate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {
        return true;
      };
      this.automaticExposuresEnabled = enabled;
      this.automaticExposuresPredicate = predicate;
    }
  }]);
  return ExposureEvents;
}();
export { ExposureEvents as default };